import {
  BaseFlowBlockSchema,
  BaseFlowNotableObjectConfigSchema,
  FlowBlockType,
  FlowGetAgentConversationConfigSchema,
  FlowGetAssistantConfigSchema,
  FlowGetEncounterContactsConfigSchema,
  FlowGetEncountersConfigSchema,
  FlowGetExternalDocumentPacketConfigSchema,
  FlowGetFeedMessagesConfigSchema,
  FlowGetGuarantorConfigSchema,
  FlowGetHl7MessageEventConfigSchema,
  FlowGetInsuranceOcrResultsConfigSchema,
  FlowGetJobContextConfigSchema,
  FlowGetNotableObjectProviderIdType,
  FlowGetPatientConfigSchema,
  FlowGetPatientInsuranceInformationConfigSchema,
  FlowGetPatientOrderConfigSchema,
  FlowGetPatientUploadConfigSchema,
  FlowGetPaymentConfigSchema,
  FlowGetPracticeConfigSchema,
  FlowGetPrimaryCareProviderConfigSchema,
  FlowGetReferenceTableConfigSchema,
  FlowGetSftpMessageEventConfigSchema,
  FlowGetTemplateConfigSchema,
  FlowGetX12MessageEventConfigSchema,
  FlowNotableObject,
} from 'flow-schema';
import { z } from 'zod';

export const GetProviderConfigSchema = BaseFlowNotableObjectConfigSchema.extend({
  notableObject: z.literal(FlowNotableObject.Provider),
  providerIdType: z.enum(FlowGetNotableObjectProviderIdType).optional(),
  isSelectMultipleProviderIdsEnabled: z.boolean().default(false),
  providerId: z.string().optional(),
});

export const GetNotableObjectConfigSchema = z.discriminatedUnion('notableObject', [
  FlowGetReferenceTableConfigSchema,
  FlowGetPaymentConfigSchema,
  FlowGetAgentConversationConfigSchema,
  FlowGetHl7MessageEventConfigSchema,
  FlowGetGuarantorConfigSchema,
  FlowGetPatientOrderConfigSchema,
  GetProviderConfigSchema,
  FlowGetTemplateConfigSchema,
  FlowGetExternalDocumentPacketConfigSchema,
  FlowGetPatientConfigSchema,
  FlowGetPracticeConfigSchema,
  FlowGetSftpMessageEventConfigSchema,
  FlowGetX12MessageEventConfigSchema,
  FlowGetPatientUploadConfigSchema,
  FlowGetPatientInsuranceInformationConfigSchema,
  FlowGetEncountersConfigSchema,
  FlowGetPrimaryCareProviderConfigSchema,
  FlowGetFeedMessagesConfigSchema,
  FlowGetEncounterContactsConfigSchema,
  FlowGetInsuranceOcrResultsConfigSchema,
  FlowGetJobContextConfigSchema,
  FlowGetAssistantConfigSchema,
]);

export type GetNotableObjectConfig = z.infer<typeof GetNotableObjectConfigSchema>;

export const GetNotableObjectBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(FlowBlockType.GetNotableObject),
  config: GetNotableObjectConfigSchema,
});

export type GetNotableObjectBlock = z.infer<typeof GetNotableObjectBlockSchema>;
